export const QA_NAME_GRETA_AI_CHAT_NEW_PROJECT_INPUT =
  'gretaAIChatNewProjectInput'

export const QA_NAME_GRETA_AI_CHAT_NEW_PROJECT_CANCEL =
  'gretaAIChatNewProjectCancel'

export const QA_NAME_GRETA_AI_CHAT_NEW_PROJECT_SUBMIT =
  'gretaAIChatNewProjectSubmit'
